import styled from 'styled-components'

const Layout = styled.div`
  display: grid;
  grid-template:
    'header close' minmax(36px, auto)
    'main aside' auto / 1048px 304px;
  grid-gap: 8px;
`
export default Layout
